import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssetRepresentationPersistRequest } from '../model/requests/asset-representation-persist-request';
import { BasicFilters } from '../model/filters/basic-filters';
import { HttpUtils } from '../shared/http.utils';
import { AssetRepresentationsResponse } from '../model/responses/asset-representations-response';

@Injectable({
  providedIn: 'root'
})
export class AssetRepresentationsService {

  private readonly assetRepresentationColorPreferences: Map<string, string>;
  private readonly imageStatusTypes: string[] = ['OK', 'ALARM', 'WARNING', 'INACTIVITY'];

  private readonly representationsURL: string;

  constructor(private http: HttpClient) {
    this.representationsURL = '/catalog/asset-representations';
    this.assetRepresentationColorPreferences = new Map();
  }

  public getAssetRepresentations(offset?: number, limit?: number, filters?: BasicFilters): Observable<AssetRepresentationsResponse>{
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = filters ?? new BasicFilters();
    return this.http.post<AssetRepresentationsResponse>(this.representationsURL, body, options);
  }

  getAllAssetRepresentationIcons(): Observable<any> {
    const url = `${this.representationsURL}/icons`;
    return this.http.get<any>(url);
  }

  getAllAssetRepresentationNames(): Observable<any> {
    const url = `${this.representationsURL}/names`;
    return this.http.get<any>(url);
  }

  public createAssetRepresentation(assetRepresentationCreationData: AssetRepresentationPersistRequest): Observable<any> {
    const url = `${this.representationsURL}/create`;
    return this.http.post<any>(url, assetRepresentationCreationData);
  }

  public editAssetRepresentation(assetRepresentationCreationData: AssetRepresentationPersistRequest): Observable<any> {
    const url = `${this.representationsURL}/edit`;
    return this.http.post<any>(url, assetRepresentationCreationData);
  }

  public deleteAssetRepresentations(identifiers: {tenantUuid: string, name: string}[]): Observable<HttpResponse<any>> {
    const url = `${this.representationsURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

  public buildAssetRepresentationPreferences(preferences: any): void{
    if(this.assetRepresentationColorPreferences.size === 0){
      this.imageStatusTypes.forEach((type: string): void => {
        this.assetRepresentationColorPreferences.set(type, preferences.customStatusAssetRepresentation[type.toLowerCase()]);
      });
    }
  }

  public getImageStatusTypes(): string[]{
    return this.imageStatusTypes;
  }

  public getColorFromLoadedPreferences(status: string): string{
    return this.assetRepresentationColorPreferences.get(status);
  }

}
